import { Stack, Title, Text, Card, Grid, Group, Badge, Button } from '@mantine/core';
import { IconPlus, IconMessageCircle, IconStar, IconAlertCircle, IconChecks } from '@tabler/icons-react';

/**
 * FeedbackDashboard Component
 * Main dashboard for Feedback domain
 */
export default function FeedbackDashboard() {
  return (
    <Stack gap="md">
      <Group justify="space-between" align="center">
        <div>
          <Title order={2}>Feedback Dashboard</Title>
          <Text size="sm" c="dimmed">
            Manage member feedback and suggestions
          </Text>
        </div>
        <Button leftSection={<IconPlus size={16} />} variant="filled">
          New Feedback
        </Button>
      </Group>

      <Grid>
        <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
          <Card shadow="sm" padding="lg" radius="md" withBorder>
            <Stack gap="xs">
              <Group justify="space-between">
                <IconMessageCircle size={24} color="var(--mantine-color-blue-6)" />
                <Badge color="blue" variant="light">
                  New
                </Badge>
              </Group>
              <Text size="xl" fw={700}>
                15
              </Text>
              <Text size="sm" c="dimmed">
                Pending Review
              </Text>
            </Stack>
          </Card>
        </Grid.Col>

        <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
          <Card shadow="sm" padding="lg" radius="md" withBorder>
            <Stack gap="xs">
              <Group justify="space-between">
                <IconStar size={24} color="var(--mantine-color-yellow-6)" />
                <Badge color="yellow" variant="light">
                  Ratings
                </Badge>
              </Group>
              <Text size="xl" fw={700}>
                4.6
              </Text>
              <Text size="sm" c="dimmed">
                Average Rating
              </Text>
            </Stack>
          </Card>
        </Grid.Col>

        <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
          <Card shadow="sm" padding="lg" radius="md" withBorder>
            <Stack gap="xs">
              <Group justify="space-between">
                <IconAlertCircle size={24} color="var(--mantine-color-red-6)" />
                <Badge color="red" variant="light">
                  Urgent
                </Badge>
              </Group>
              <Text size="xl" fw={700}>
                3
              </Text>
              <Text size="sm" c="dimmed">
                Needs Attention
              </Text>
            </Stack>
          </Card>
        </Grid.Col>

        <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
          <Card shadow="sm" padding="lg" radius="md" withBorder>
            <Stack gap="xs">
              <Group justify="space-between">
                <IconChecks size={24} color="var(--mantine-color-green-6)" />
                <Badge color="green" variant="light">
                  Resolved
                </Badge>
              </Group>
              <Text size="xl" fw={700}>
                48
              </Text>
              <Text size="sm" c="dimmed">
                This Month
              </Text>
            </Stack>
          </Card>
        </Grid.Col>
      </Grid>

      <Card shadow="sm" padding="lg" radius="md" withBorder>
        <Title order={4} mb="md">
          Recent Feedback
        </Title>
        <Text c="dimmed">Feedback list will be implemented here...</Text>
      </Card>
    </Stack>
  );
}
